module.exports = __webpack_public_path__ + "img/portfolio-05.5dee8713.a363c351.jpg";